import { USER_ROLE } from './user/types';

export const authorizeUser = (
  userRoles: USER_ROLE[],
  authorizationRoles: USER_ROLE[]
) => Boolean(userRoles.find(role => authorizationRoles.includes(role)));

export const isAdmin = (userRoles: USER_ROLE[]) =>
  authorizeUser(userRoles, ['SuperAdmin']);

export const isOnlyMyLinksUser = (userRoles: USER_ROLE[]) =>
  authorizeUser(userRoles, ['OnlyMyLinksUser']);

export const isLocalRole = (role: USER_ROLE) =>
  ['LocalContentAdmin', 'LocalUserAdmin'].includes(role);

export const isLocalContentAdmin = (roles: USER_ROLE[]) =>
  roles.includes('LocalContentAdmin') &&
  !roles.includes('SuperAdmin') &&
  !roles.includes('ContentAdmin');

export const isLocalUserAdmin = (roles: USER_ROLE[]) =>
  roles.includes('LocalUserAdmin') &&
  !roles.includes('SuperAdmin') &&
  !roles.includes('UserAdmin');

export const toggleRole = (
  roles: USER_ROLE[],
  role: USER_ROLE,
  on?: boolean
) => {
  const condition = on !== undefined ? on : !roles.includes(role);
  return condition ? [...roles, role] : roles.filter(r => r !== role);
};



// WEBPACK FOOTER //
// ./src/services/authorizeUser.ts